import { render, staticRenderFns } from "./LearningProfile.vue?vue&type=template&id=49d5acb2&scoped=true"
import script from "./LearningProfile.vue?vue&type=script&lang=js"
export * from "./LearningProfile.vue?vue&type=script&lang=js"
import style0 from "./LearningProfile.vue?vue&type=style&index=0&id=49d5acb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d5acb2",
  null
  
)

export default component.exports